import { CardProps, Card } from "@material-ui/core";
import React from "react";
//@ts-ignore
import { useBouncyShadowStyles } from "@mui-treasury/styles/shadow/bouncy";

export const BouncyShadowCard: React.FC<Omit<CardProps, "variant">> = props => {
  const styles = useBouncyShadowStyles();
  return <Card {...props} classes={styles} />;
};
